import { formatLocalizedNumber } from '../utils/i18n/numberFormattingUtils';

const SUFFIXES = ['GB', 'MB', 'KB', 'B'];
const SUFFIX_DECIMALS = {
    GB: 1,
    MB: 1,
};
const SUFFIX_TRANSLATION_KEYS = {
    GB: 'fileSizeUnits.gb',
    MB: 'fileSizeUnits.mb',
    KB: 'fileSizeUnits.kb',
    B: 'fileSizeUnits.b',
};

const getDivisorForSuffix = (suffix) => {
    let suffixIndex = SUFFIXES.indexOf(suffix);
    if (suffixIndex === -1) {
        suffixIndex = 0;
    }

    return Math.pow(1000, SUFFIXES.length - 1 - suffixIndex);
};

export const getSizeIn = (suffix, size, minimise = false, locale) => {
    const result = size / getDivisorForSuffix(suffix);

    let numDecimals = SUFFIX_DECIMALS[suffix] || 0;

    // If we are working with a confined space, don't show decimals for large numbers
    if ((minimise && result >= 10) || result >= 100) {
        numDecimals = 0;
    }

    return formatLocalizedNumber(result, {
        localePreference: locale,
        maximumFractionDigits: numDecimals,
        minimumFractionDigits: numDecimals,
        useGrouping: false,
    });
};

export const getFileSizeSuffix = (size = 0) =>
    SUFFIXES.reduce((sizeString, suffix, index) => {
        if (sizeString) return sizeString;

        const result = getSizeIn(suffix, size);
        if (result >= 1) return suffix;

        return null;
    }, null) || 'B';

const getDisplaySuffix = (suffix, translate) => {
    if (!translate) return suffix;

    const translationKey = SUFFIX_TRANSLATION_KEYS[suffix];
    if (!translationKey) return suffix;

    const translated = translate(translationKey);
    return translated && translated !== translationKey ? translated : suffix;
};

export const getFileSizeForDisplay = (size = 0, translate, locale) => {
    const suffix = getFileSizeSuffix(size);
    const result = getSizeIn(suffix, size, false, locale);
    return `${result} ${getDisplaySuffix(suffix, translate)}`;
};

export const getFileSizeComparisonParts = (partial, total, minimise = false, translate, locale) => {
    const suffix = getFileSizeSuffix(total);
    const totalFormatted = getSizeIn(suffix, total, minimise, locale);
    const partialFormatted = getSizeIn(suffix, partial, minimise, locale);

    return {
        suffix: getDisplaySuffix(suffix, translate),
        totalFormatted,
        partialFormatted,
    };
};

export const getFileSizeComparisonString = (partial, total, minimise = false, translate, locale) => {
    const { suffix, totalFormatted, partialFormatted } = getFileSizeComparisonParts(
        partial,
        total,
        minimise,
        translate,
        locale,
    );
    return `${partialFormatted} / ${totalFormatted} ${suffix}`;
};
